<template>
    <v-content>
      <v-container class="fill-height" fluid >
        <v-row align="center" justify="center">
          <v-col>
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Not yet implemented</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                This component has not yet been implemented.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
</template>

<script>
export default {
  name: 'NotYetImplemented',
  computed: {}
}
</script>

<style>
</style>
